<template>
    <div>
        <list
        row-key="RecordId"
        ref="list"
        unit="门店信息"
        :page="page"
        :query-params="params"
        :show-checkbox="$permission.canDel()"
        :show-query="showQuery"
        :get-data-func="api.list"
      >
        <template slot="toolbar-right">
          <slot name="toolbar-right"></slot>
        </template>
        <template slot="query">
         <el-form-item label="门店名称">
            <el-input v-model="params.StoreName" placeholder="请输入门店名称" clearable />
          </el-form-item>
          <el-form-item label="商家名称">
            <el-input v-model="params.BusiName" placeholder="请输入商家名称" clearable />
          </el-form-item>
          <el-form-item label="所属区域">
            <el-input v-model="params.DistrictNameChain" placeholder="请输入所属区域" clearable />
          </el-form-item>
          <el-form-item label="门店类型">
            <el-select size="mini" v-model="params.StoreType" placeholder="请选择门店类型" clearable>
                <el-option label="自营" :value="0"></el-option>
                <el-option label="加盟" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数据来源">
            <el-select size="mini" v-model="params.DataSource" placeholder="请选择数据来源" clearable>
                <el-option label="平台添加" :value="0"></el-option>
                <el-option label="申请入驻" :value="1"></el-option>
            </el-select>
          </el-form-item>
                  
         
          <el-form-item label="状态">
            <el-select size="mini" v-model="params.State" placeholder="请选择状态" clearable>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="停用" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="table">
          <el-table-column prop="OrderId" label="序号" width="60" align="center" />
          <el-table-column prop="StoreName" label="门店名称" />
          <el-table-column prop="StoreCode" label="门店编号" />
          <el-table-column prop="BusiName" label="商家名称" />
          <el-table-column prop="DistrictNameChain" label="所属区域" show-overflow-tooltip /><!--show-overflow-tooltip 较长时显示省略号 鼠标在上面时显示内容-->
        
          <el-table-column prop="StoreType" align="center" label="店铺类型" width="80">
            <template slot-scope="{ row }">
                {{ row.StoreType==0?"自营":"加盟" }}     <!--内容不需要显示样式或图标的，只显示数据的，则直接用这句话即可-->
            </template>
          </el-table-column>
        
          <el-table-column label="营业时间" min-width="110">
            <template slot-scope="{row}">
              {{ toTimeString(row.TradeTimebegin) }} - {{ toTimeString(row.TradeTimeend) }}
            </template>
          </el-table-column>
        
          <el-table-column prop="DataSource" align="center" label="数据来源" width="80">
            <template slot-scope="{ row }">
                {{ row.DataSource==0?"平台添加":"申请入驻" }}     <!--内容不需要显示样式或图标的，只显示数据的，则直接用这句话即可-->
            </template>
          </el-table-column>
          <el-table-column prop="State" align="center" label="状态" width="80">
            <template slot-scope="{ row }">
              <el-tag size="small" type="success" v-if="row.State==1">启用</el-tag>
              <el-tag size="small" type="danger" v-else-if="row.State==0">停用</el-tag>
            </template>
          </el-table-column>
          <!-- slot[column] -->
          <slot name="column"></slot>
          <!--/ slot[column]-->
        </template>
      </list>
    </div>
  </template>
  <script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  
  export default {
    mixins: [listMixin],
    components: {
      list,
    },
    data() {
      return {
        api: require("@/api/shop/store").default,  
        //
        params: {
          ShopName: "",
          BusiName: "",
          StoreType: null,
          DistrictNameChain: "",
          DataSource:null,
          DbSource:null,
          State: null,
        },
     
      };
    },
    mounted() {
     
    },
    methods: {
      toTimeString(v) {
        if(v) {
          var arr = v.split(":");
          return arr[0] + ":" + arr[1];
        }
      },
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    }
  };
  </script>